import { Stack, Group, Button, Tabs } from '@mantine/core';
import { useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import cn from 'clsx';
import { StakePanel } from './StakePanel';
import { UnstakePanel } from './UnstakePanel';
import { Stats } from './Stats';

const TABS = ['stake', 'unstake'];

const setTabFromSearchParams = (tabFromSearchParams?: string) => {
  const matchingTab = TABS.find((tab) => tabFromSearchParams?.startsWith(tab));
  return matchingTab ?? TABS[0];
};

export function StakePage() {
  const [_searchParams, setSearchParams] = useSearchParams();
  const searchParams = Object.fromEntries(_searchParams.entries());
  const tabFromSearchParams = searchParams?.tab;
  const [activeTab, setActiveTab] = useState(
    setTabFromSearchParams(tabFromSearchParams)
  );

  useEffect(() => {
    setActiveTab(setTabFromSearchParams(tabFromSearchParams));
  }, [tabFromSearchParams]);

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    setSearchParams({ tab: value });
  };

  return (
    <Stack gap={64}>
      <Stack gap={36}>
        <Group
          justify="center"
          gap={8}
          wrap="nowrap"
          p={2}
          className="self-center bg-[#0B0B0E] rounded-[36px] border border-solid border-[#151519]"
        >
          {TABS.map((tab) => (
            <Button
              key={tab}
              w={160}
              h={45}
              variant="outline"
              className={cn(
                'rounded-[32px]',
                'text-[#3E3E4C] hover:text-[#fff] active:text-[#fff] capitalize hover:bg-primarybrand/[0.10]',
                tab === activeTab
                  ? 'border-secondarybrand bg-[linear-gradient(83deg,rgba(154,238,230,0.24)_7.98%,rgba(0,67,74,0.02)_43.13%,rgba(0,67,74,0.12)_80.3%)] text-[#fff]'
                  : 'border-transparent'
              )}
              onClick={() => handleTabChange(tab)}
            >
              {tab}
            </Button>
          ))}
        </Group>

        <Tabs value={activeTab}>
          <Tabs.Panel value="stake">
            <StakePanel apy={<Stats.APY />} />
          </Tabs.Panel>

          <Tabs.Panel value="unstake">
            <UnstakePanel />
          </Tabs.Panel>
        </Tabs>
      </Stack>

      <Stats />
    </Stack>
  );
}
